<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="center ">First U.S. edition</p>
<div class="timebreak "> </div>
<p class="center ">First Mariner Books edition 2017</p>
<div class="timebreak "> </div>
<p class="center ">Copyright © 2015 by Sara Baume</p>
<p class="center ">Reading Group Guide Questions and Discussion Points copyright © 2017 by Houghton Mifflin Harcourt Publishing Company</p>
<p class="center ">Q&amp;A with Author copyright © 2017 by Sara Baume</p>
<p class="center ">Cover design © Suzanne Dean</p>
<p class="center ">Cover illustration based on an etching by Helen Fay</p>
<p class="center ">Author photograph © Patrick Bolger</p>
<div class="timebreak "> </div>
<p class="center ">First published in the Republic of Ireland by Tramp Press in 2015</p>
<div class="timebreak "> </div>
<p class="center ">All rights reserved</p>
<div class="timebreak "> </div>
<p class="center ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="center "><a href="http://www.hmhco.com" target="_blank">www.hmhco.com</a></p>
<div class="timebreak "> </div>
<p class="center "><em>Library of Congress Cataloging-in-Publication Data:</em><br/>
Names: Baume, Sara, author.</p>
<p class="center ">Title: Spill simmer falter wither / Sara Baume.</p>
<p class="center ">Description: First U.S. edition. | Boston : Houghton Mifflin Harcourt, 2016.<br/>
2015 Identifiers: <span class="smallcaps">LCCN</span> 2015037012 | <span class="smallcaps">ISBN</span> 9780544716193 (hardcover) | <span class="smallcaps">ISBN</span> 9780544716223 (ebook) | <span class="smallcaps">ISBN</span> 9780544954618 (pbk.)<br/>
Subjects: <span class="smallcaps">LCSH:</span> Human-animal relationships—Fiction. Dog owners—Fiction.<br/>
<span class="smallcaps">BISAC: FICTION</span> / Literary. | <span class="smallcaps">FICTION</span> / General.<br/>
Classification: <span class="smallcaps">LCC</span> PR6102.A86 S65 2016 | <span class="smallcaps">DDC</span> 823/.92—dc23<br/>
<span class="smallcaps">LC</span> record available at <a href="http://lccn.loc.gov/2015037012" target="_blank">http://lccn.loc.gov/2015037012</a></p>
<div class="timebreak "> </div>
<p class="center ">v3.0217</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?0b6cb804